export const notificationServicesFields = {
  BAL_VESTED: {
    key: 'vestedBalance',
    label: 'Balance (vested)',
    type: 'string',
  },
  BAL_TOTAL: {
    key: 'totalBalance',
    label: 'Balance (total)',
    type: 'string',
  },
  DATE_OF_BALANCE: {
    key: 'dateOfBalance',
    label: 'Date of balance',
    type: 'string',
  },
  REASON_ROLLOUT_REQ: {
    key: 'reason',
    label: 'Reason for rollout request',
    type: 'string',
  },
  GRACE_PERIOD_TO_RESPOND: {
    key: 'gracePeriod',
    label: 'Grace period for participant to respond',
    type: 'string',
  },
  COMPANY_NAME: {
    key: 'companyName',
    label: 'Rollout help company name',
    type: 'string',
  },
  COMPANY_ADDRESS_1: {
    key: 'companyAddressLine1',
    label: 'Rollout help company address line 1',
    type: 'string',
  },
  COMPANY_ADDRESS_2: {
    key: 'companyAddressLine2',
    label: 'Rollout help company address line 2',
    type: 'string',
  },
  COMPANY_CITY: {
    key: 'companyCity',
    label: 'Rollout help company city',
    type: 'string',
  },
  COMPANY_STATE: {
    key: 'companyState',
    label: 'Rollout help company state',
    type: 'string',
  },
  COMPANY_ZIP: {
    key: 'companyZipCode',
    label: 'Rollout help company zip code',
    type: 'string',
  },
  COMPANY_CONTACT_PHONE: {
    key: 'companyPhone',
    label: 'Rollout help company phone',
    type: 'string',
  },
  COMPANY_WEBSITE: {
    key: 'companyWebsite',
    label: 'Rollout help company website',
    type: 'string',
  },
  COMPANY_CONTACT_EMAIL: {
    key: 'companyEmail',
    label: 'Rollout help company email',
    type: 'string',
  },
}
